import { useMemo } from 'react';
import { useMutation, ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';
import { getHiApiServerlessUrl } from 'packages/locations';
import { bodyCompMutations } from '../graphql/mutations';

interface ConfirmBodyCompQCResponse {
  message: string;
  statusCode: number;
}

interface ConfirmBodyCompQCData {
  confirmBodyCompQC: ConfirmBodyCompQCResponse;
}

interface ConfirmBodyCompQCVars {
  studyId: string;
}

export const useConfirmBodyCompQC = (
  studyId: string,
): {
  confirmBodyCompQC: () => Promise<{ data?: ConfirmBodyCompQCData }>;
  loading: boolean;
  error?: any;
} => {
  const hiEndpoint = getHiApiServerlessUrl();
  const hiClient = useMemo(
    () =>
      new ApolloClient({
        link: new HttpLink({
          uri: hiEndpoint,
          credentials: 'include',
        }),
        cache: new InMemoryCache(),
      }),
    [hiEndpoint],
  );

  const [confirmBodyCompQCMutation, { loading, error }] = useMutation<
    ConfirmBodyCompQCData,
    ConfirmBodyCompQCVars
  >(bodyCompMutations.CONFIRM_BODY_COMP_QC, { client: hiClient });

  const confirmBodyCompQC = (): Promise<{ data?: ConfirmBodyCompQCData }> =>
    confirmBodyCompQCMutation({ variables: { studyId } });

  return {
    confirmBodyCompQC,
    loading,
    error,
  };
};
